module.exports = __webpack_public_path__ + "static/media/returnArrow.de2ffe49.svg";